module.exports = __webpack_public_path__ + "asset/image-Banknote-4fe04f3aa16deff7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Banknote.svg
// module id = r1UY
// module chunks = 0